import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ADMIN_SERVICE } from "./service-url";
import {PlatformRegionService} from '../../app/service/shared/platform-region.service'
interface Tab {
  label: string;
  content: string;
  api?: string;
}

@Injectable({
  providedIn: 'root'
})
export class TabDataService {
  userId: number = 0;
  constructor(private http: HttpClient,private PlatformRegionService:PlatformRegionService) { }

  getTabsData(product_code: string, region_name: string): Observable<any> {
  const params = new HttpParams()
    .set('business_unit_code', product_code)
    .set('region_name', region_name);
  return this.http.get(ADMIN_SERVICE.getPromptData, { params });
}

  updateTab(tab: Tab): Observable<any> {
    this.userId = Number(sessionStorage.getItem('userId'));
    const request = {
      config_module: tab.label || "",
      system_prompt: tab.content || "",
      created_by: this.userId,
      business_unit_code: sessionStorage.getItem('businessUnitCode'),
      region_name: this.PlatformRegionService.selected_region_code,

    }
    return this.http.post(ADMIN_SERVICE.createUpdatePromptData, request);
  }

  resetTabContent(tab: Tab): Observable<any> {
    const request = {
      business_unit_code: sessionStorage.getItem('businessUnitCode'),
      created_by :Number(sessionStorage.getItem('userId')) ,
      config_module : tab.api,
      region_name: this.PlatformRegionService.selected_region_code,

    }
    return this.http.post(ADMIN_SERVICE.resetPromptData,request);
  }

  versionList():Observable<any>{
    return this.http.get(`${ADMIN_SERVICE.getPromptVersionList}?business_unit_code=${sessionStorage.getItem('businessUnitCode')}&region_name=${this.PlatformRegionService.selected_region_code}`);
  }

  SystemPromptByVersion(configId):Observable<any>{
    return this.http.get(`${ADMIN_SERVICE.getSystemPromptByVersion}${configId}`);
  }
}

